import $ from 'jquery';
import { fetchAiCredits } from '~graphql/controllers';
import { onErrorShowMessage } from '~src/errors';
import { initAiCreditPackagesModal } from './initAiCreditPackagesModal';

export const handleTabImagesAI = async () => {
  // No longer render the legacy AI sidebar here. We keep this function to
  // refresh credits and any visible UI elements that show the balance.

  let credits;
  try {
    credits = await fetchAiCredits();
  } catch (error) {
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Attenzione!',
      confirmButtonColor: '#278e8e',
      text:
        'Errore nel caricamento del saldo crediti IA. Il saldo mostrato potrebbe non essere aggiornato.',
    });
    console.error(error);
    return;
  }

  if (!credits || !credits.edges || !credits.edges[0]) {
    // No credits data available, set 0 on any known targets and exit
    try {
      $('#ai-credits-balance').text(0);
      document
        .querySelectorAll('.btn-ai-credits .button-text')
        .forEach((el) => (el.textContent = 'Crediti (0)'));
    } catch (e) {
      console.error('Failed updating header AI balance', e);
    }
    return;
  }

  const totalCredits =
    credits.edges[0].freeCreditsAmount + credits.edges[0].paidCreditsAmount;

  // Update legacy sidebar badge if present
  $('#ai-credits-balance').text(totalCredits);

  // Update floating controls AI menu labels if present
  try {
    document
      .querySelectorAll('.btn-ai-credits .button-text')
      .forEach((el) => (el.textContent = `Crediti (${totalCredits})`));
  } catch (e) {
    console.error('Failed updating floating controls AI labels', e);
  }

  // Initialize the credit packages and info modals (for places that still use them)
  try {
    initAiCreditPackagesModal();
    const { initAiCreditsInfoModal } = require('./initAiCreditsInfoModal');
    initAiCreditsInfoModal();
    $('[data-toggle="tooltip"]').tooltip();
  } catch (e) {
    console.error('Failed initializing AI credits modals', e);
  }
};
